module.exports = __webpack_public_path__ + "omniv2/img/icon-pump.0bc2bad2.svg";